import { useEffect, useState } from "react";
import { Grid as MuiGrid, Stack as MuiStack } from "@mui/material";

import { Breadcrumbs, PageHeader } from "@dzambalaorg/mui-page-layout";
import { useApiCall } from "@dzambalaorg/react-hooks";
import { IAchievementItemReport, IAchievementRule } from "@framework/types";
import { Typography } from "@dzambalaorg/ui-kit";

import { AchievementRedeemButton } from "../../../../../components/buttons";
import { AchievementInfoPopover } from "./popover";
import { ReportChart } from "./chart";
import { StyledGrid } from "./styled";

export const AchievementReport = () => {
  const [rules, setRules] = useState<Array<IAchievementRule>>([]);
  const [count, setCount] = useState<Array<IAchievementItemReport>>([]);

  const { fn: getAchievementsRules } = useApiCall(
    async api => {
      return api.fetchJson({
        url: "/achievements/rules",
      });
    },
    { success: false },
  );

  const { fn: getAchievementsItemCount } = useApiCall(
    async api => {
      return api.fetchJson({
        url: "/achievements/items/count",
      });
    },
    { success: false },
  );

  useEffect(() => {
    void getAchievementsRules().then(({ rows }) => {
      setRules(rows);
    });
    void getAchievementsItemCount().then(rows => {
      setCount(rows);
    });
  }, []);

  return (
    <MuiGrid>
      <Breadcrumbs path={["dashboard", "achievements", "achievements.report"]} />

      <PageHeader message="pages.achievements.report.title" />

      <MuiGrid container size={12} spacing={2}>
        {rules.map(rule => (
          <StyledGrid size={{ xs: 4 }} key={rule.id}>
            <MuiStack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              gap={theme => theme.tokens.spacing.xl}
              mb={theme => theme.tokens.spacing.sm}
            >
              <Typography variant="h5">{rule.title}</Typography>
              <AchievementInfoPopover rule={rule} count={count.find(item => item.achievementRuleId === rule.id)!} />
            </MuiStack>
            <ReportChart count={count.find(item => item.achievementRuleId === rule.id)!} achievementRule={rule} />
            <AchievementRedeemButton
              achievementRule={rule}
              count={count.find(item => item.achievementRuleId === rule.id)!}
            />
          </StyledGrid>
        ))}
      </MuiGrid>
    </MuiGrid>
  );
};
